var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeviceCameraLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    enableBackground: "new 0 0 60 60",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M30,23.6c4.1,0,7.4,3.4,7.4,7.5c0,4.1-3.3,7.5-7.4,7.5v1.2c4.7,0,8.5-3.9,8.5-8.7c0-4.8-3.8-8.7-8.5-8.7  M30,22.4c-4.7,0-8.5,3.9-8.5,8.7c0,4.8,3.8,8.7,8.5,8.7v-1.2c-4.1,0-7.4-3.4-7.4-7.5c0-4.1,3.3-7.5,7.4-7.5 M30,21.6 c5.1,0,9.3,4.2,9.3,9.5c0,5.2-4.2,9.5-9.3,9.5l0,4.2h20.5c0.8,0,1.4-0.6,1.4-1.4V18.1c0-0.8-0.6-1.4-1.4-1.4H36V16 c0-0.4-0.3-0.7-0.7-0.7H24.8v0c-0.4,0-0.7,0.3-0.7,0.7v0.7H9.5c-0.8,0-1.4,0.6-1.4,1.4v25.3c0,0.8,0.6,1.4,1.4,1.4H30l0-4.2 c-5.1,0-9.3-4.2-9.3-9.5C20.7,25.8,24.9,21.6,30,21.6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceCameraLight);
export default __webpack_public_path__ + "static/media/device-camera-light.58273cb424482a1016c70370c63ecde6.svg";
export { ForwardRef as ReactComponent };